module.exports = __webpack_public_path__ + "static/elizabeth-blog-04-2a655dabc0eeeb3c0120723764f6e36f.jpg";